import {setItem, getItem, removeItem, getItemWithExpiry, setItemWithExpiry} from '../localStorageUtils';
import {getSessionId} from '../userStorageAPI/localStorageAPI';
import {removeCookieItem} from '../../utilities/cookieUtils';
import axios from 'axios';
import Config from '../../Config';
import replacer from 'string-placeholder';
import uuid from 'react-uuid';
import ProviderManager from '../../provider/providerManager';
import loginSubTypes from '../../constans/loginSubTypes';
import {report, getReportParams} from '../../middleware/report';
import {getRecaptchaToken} from '../recaptcha/recaptcha';
import EpiContext from '@episerver/spa-core/Spa';
import {setOrganizationDataAction, setCustomerType, setOrgId} from '../../Components/Block/WelcomeBlock/welcomeBlockSlice';
import {setRedirectUrl, forceExtendedOtp} from './authenticationSlice';
import {
  setOrgIdSelfCare,
  setOrganizationDataActionSelfCare,
  setCustomerTypeSelfCare,
} from '../../Components/Page/SelfCarePage/SelfCareSlice';
import {setIsCustomerInitLoaded} from '../../Components/Block/CoreProductActionsBlock/CoreProductActionsSlice';
import {isOrganizationId} from '../../Components/Block/SelfCareNavBarBlock/selfCareNavBarSlice';
import {navigateToUrl} from '../../utilities/StringHelpers/StringHelpers';
import {Onboarding} from '../../Components/Page/SelfCarePage/SelfCareAsyncThunk';
import helper from '../helper';
const reportTracking = () => {
  try {
    let reportParams = getReportParams();
    reportParams.area = 'GeneralSite';
    reportParams.subArea = 'tracking';
    reportParams.channel = 'WebsitePrivate';
    reportParams.actionType = 'TrackingId fetched from remote';
    reportParams.status = 'Completed';
    reportParams.messageText = 'siteloading with customerInit value';
    reportParams.subscriber = '';
    reportParams.param1 = 'WEBSITE';
    report(reportParams);
  } catch (ex) {
    // nothing to do
  }
};
const setOrganizationDataNewSelfCare = async (customerData) => {
  const store = await EpiContext.getStore();
  store.dispatch(setOrganizationDataActionSelfCare(customerData.Body.organizationData));
  store.dispatch(setCustomerTypeSelfCare(customerData.Body.customerType));
  store.dispatch(setOrgIdSelfCare(customerData.Body.orgId));
};

const setOrganizationDataOldWelcomeBlock = async (customerData) => {
  const store = await EpiContext.getStore();
  store.dispatch(setOrganizationDataAction(customerData.Body.organizationData));
  store.dispatch(setCustomerType(customerData.Body.customerType));
  store.dispatch(setOrgId(customerData.Body.orgId));
  store.dispatch(isOrganizationId(customerData.Body.organizationId));
  store.dispatch(setIsCustomerInitLoaded(true));
};

const redirectToLogin_new = (returnUrl, cancelUrl, template, replacePath = true) => {
  if (returnUrl === Config.idfSaleUrl || returnUrl === Config.idfLobbyUrl) {
    return EpiContext.navigateTo(Config.idfLoginUrl);
  }
  const loginUrlFull = `${Config.staticWebSiteUrl}${Config.newFullLoginUrl}?returnUrl=${encodeURIComponent(
    returnUrl,
  )}&loginTemplate=${template}`;
  if (replacePath === true) window.location.replace(loginUrlFull);
  else window.location.assign(loginUrlFull);
};

const redirectToLogin_old = (returnUrl, cancelUrl, template, replacePath = true) => {
  if (returnUrl === Config.idfSaleUrl || returnUrl === Config.idfLobbyUrl) {
    return EpiContext.navigateTo(Config.idfLoginUrl);
  }
  let hash = getItem('auth_hash');
  if (hash === undefined) {
    hash = uuid();
    setItem('auth_hash', hash);
  }

  const sessionId = getSessionId();

  const loginUrl = replacer(Config.loginUrlTemplate, {
    client_id: Config.client_id,
    siteScope: Config.siteScope,
    loginType: 'NEWCREDENTIALS',
    template: template ? template : Config.defaultLoginTemplate,
    returnUrl: returnUrl,
    cancelUrl: cancelUrl,
    sid: sessionId,
    hash: hash,
  });
  setItem('return_url', returnUrl);
  if (replacePath === true) window.location.replace(loginUrl);
  else window.location.assign(loginUrl);
};

const AuthenticationProvider = {
  getSavedTokenFromStore: async () => {
    const store = await EpiContext.getStore().getState();
    const token = store.authentication?.loginData?.token;
    return token && typeof token == 'string' ? token : null;
  },
  getSavedToken: () => getItem('auth_token'),
  saveToken: (token) => setItem('auth_token', token),
  getRefreshToken: () => getItem('refresh_token'),
  saveRefreshToken: (refreshToken) => setItem('refresh_token', refreshToken),
  getLoginData: () => getItem('login_data'),
  saveLoginData: (loginData) => setItem('login_data', loginData),
  //save in store everything Moran needs in the header
  getHash: () => getItem('auth_hash'),
  saveHash: (hash) => setItem('auth_hash', hash),
  launchInContextRedirect: ({
    clientId,
    scope,
    token,
    idNumber,
    phoneNumber,
    returnUrl,
    ban,
    loginType,
    templateId,
    actionType,
    redirectUrl,
    orgIdNumber,
    consumerId,
    guidId,
  }) => {
    if (actionType === 'LoginEcommerce') {
      navigateToUrl(returnUrl);
      return;
    } else if (actionType === 'ComplitRegistrationEcommerce') {
      clientId = Config.client_id;
      scope = 'PRIVATE_WEBSITE';
      loginType = 'COMPLETEREGISTRATION';
      returnUrl = redirectUrl;
    }

    let hash = getItem('auth_hash');
    if (hash === undefined) {
      hash = uuid();
      setItem('auth_hash', hash);
    }
    const sessionId = getSessionId();

    let loginUrl = replacer(Config.loginUrlTemplate, {
      client_id: clientId,
      siteScope: scope,
      loginType: loginType,
      template: '',
      returnUrl: returnUrl,
      cancelUrl: '',
      sid: sessionId,
      hash: hash,
    });

    if (templateId) {
      loginUrl += '&token=' + token + '&phoneNumber=' + phoneNumber + '&idNumber=' + idNumber + '&templateId=' + templateId;
    } else {
      loginUrl = loginUrl.replace('&templateId=', '');
      loginUrl += '&token=' + token + '&phoneNumber=' + phoneNumber + '&idNumber=' + idNumber;
    }

    if (ban) {
      loginUrl += '&ban=' + ban;
    }
    if (orgIdNumber) {
      loginUrl += '&orgIdNumber=' + orgIdNumber;
    }
    if (actionType === 'OwnershipTransfer' || actionType === 'CouponHistory') {
      loginUrl += '&actionType=' + actionType;
    }
    if (consumerId) {
      loginUrl += '&consumerId=' + consumerId;
    }
    if (guidId && actionType === 'Invoice') {
      sessionStorage.setItem('invoiceIframeData', JSON.stringify({ id: guidId }))
    }

    window.location.replace(loginUrl);
  },
  redirectToLogin: (returnUrl, cancelUrl, template, replacePath = true) => {
    if (returnUrl === Config.idfSaleUrl || returnUrl === Config.idfHomePageUrl) {
      return EpiContext.navigateTo(Config.idfLoginUrl);
    }
    if (template == null || template == undefined || template == '') {
      template = helper.getLoginTemplate(returnUrl);
    }
    if (Config.useOldLogin) {
      redirectToLogin_old(returnUrl, cancelUrl, template, replacePath);
    } else {
      redirectToLogin_new(returnUrl, cancelUrl, template, replacePath);
    }
  },
  goToOtp: async (shouldRedirect = false, redirectToPath = null, forceExtended = false , loginType = "") => {
    const store = await EpiContext.getStore();
    let returnPath = null;
    if (shouldRedirect) {
      if (redirectToPath && redirectToPath != '') {
        returnPath = redirectToPath;
        store.dispatch(setRedirectUrl(redirectToPath));
      } else if (window.location.pathname && window.location.pathname != null) {
        returnPath = window.location.pathname + window.location.search;
        store.dispatch(setRedirectUrl(returnPath));
      }
    }
    store.dispatch(forceExtendedOtp(forceExtended));

    // Replace (don't push) so Back from login won't land on the protected page and loop
    // Pass loginType via query string — Redux is wiped on full page reload
    let loginUrl = `${Config.staticWebSiteUrl}${Config.newLoginUrl}`;
    const queryParams = [];
    if (returnPath) {
      let decodedPath = returnPath;
      try {
        decodedPath = decodeURIComponent(returnPath);
      } catch {
        // keep original
      }
      queryParams.push(`returnUrl=${encodeURIComponent(decodedPath)}`);
    }
    if (loginType) {
      queryParams.push(`loginType=${loginType}`);
    }
    if (queryParams.length) {
      loginUrl += `?${queryParams.join('&')}`;
    }
    window.location.replace(loginUrl);
  },
  createOtpLogin: async (phoneNumber, sendAsTextToSpeech, configName, otpOrigin, originProcess) => {
    const captchaToken = await getRecaptchaToken('createOTPLogin');

    const requestConfig = {
      method: 'put',
      baseURL: Config.apiGwUrl,
      url: '/otp/Step1Auth',
      data: {
        captchaToken: captchaToken,
        clientId: Config.client_id,
        phoneNumber: phoneNumber,
        scope: Config.siteScope,
        sendAsTextToSpeech: sendAsTextToSpeech,
        configName: configName,
        OtpOrigin: otpOrigin ?? '',
        OriginProcess: originProcess ?? '',
        
      },
    };

    try {
      const requestResult = await axios(requestConfig);
      return requestResult;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  createOtpLoginStep2: async (
    phoneNumber,
    otpCode,
    guid,
    restrictCode,
    termsAccepted,
    checkPhoneNumber,
    loginType,
    idNumber,
    customerEmail,
    processType,
    otpOrigin,
    originProcess,
    genericFields,
  ) => {
    const captchaToken = await getRecaptchaToken('createOTPLogin');
    const sessionId = getSessionId();
    const requestConfig = {
      method: 'put',
      baseURL: Config.apiGwUrl,
      url: '/otp/LoginStep2',
      data: {
        Guid: guid,
        OtpCode: otpCode,
        Subscriber: phoneNumber,
        RestrictCode: restrictCode,
        TermsAccepted: termsAccepted,
        CheckPhoneNumber: checkPhoneNumber ?? '',
        LoginType: loginType ?? '',
        idNumber: idNumber ?? '',
        CustomerEmail: customerEmail ?? '',
        ProcessType: processType ?? '',
        OtpOrigin: otpOrigin ?? '',
        OriginProcess: originProcess ?? '',
        GenericFields: genericFields ?? '',
      },
      headers: {
        Sessionid: sessionId,
        'X-Cell-Recaptcha-Token': captchaToken,
      },
      withCredentials: process.env.NODE_ENV !== 'development',
      withXSRFToken: true,
      xsrfCookieName: 'EEDS',
      xsrfHeaderName: 'X-XSRF-TOKEN',
    };

    try {
      const requestResult = await axios(requestConfig);
      return requestResult;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  validateOtpLogin: async (phoneNumber, ticketId, code, restrictedCode, otpOrigin, originProcess) => {
    const captchaToken = await getRecaptchaToken('validateOTPLogin');

    const requestConfig = {
      method: 'put',
      baseURL: Config.apiGwUrl,
      url: '/otp/Step2Auth',
      data: {
        captchaToken: captchaToken,
        clientId: Config.client_id,
        scope: Config.siteScope,
        phoneNumber: phoneNumber,
        otpCode: code,
        otpTicketId: ticketId,
        restrictedCode: restrictedCode,
        OtpOrigin: otpOrigin ?? '',
        OriginProcess: originProcess ?? '',
      },
      withCredentials: process.env.NODE_ENV !== 'development',
      withXSRFToken: true,
      xsrfCookieName: 'EEDS',
      xsrfHeaderName: 'X-XSRF-TOKEN',
    };

    try {
      const requestResult = await axios(requestConfig);
      return requestResult;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  getToken: async (tempToken, saveNewTokenToStorage) => {
    const requestConfig = {
      method: 'post',
      baseURL: Config.loginApiUrl,
      url: '/api/token',
      data: {},
      headers: {
        Authorization: 'Bearer ' + tempToken,
        'Content-Type': 'application/json',
        Scope: Config.siteScope,
        Grant_type: 'implicit',
        Hash: getItem('auth_hash'),
      },
    };

    try {
      const requestResult = await axios(requestConfig);
      const token = requestResult.data?.Body;
      if (token && saveNewTokenToStorage === true) {
        setItem('auth_token', token.access_token);
        setItem('refresh_token', token.refresh_token);
      }

      return token;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  

  clearAuthenticationData: async () => {
    try {
      await removeItem('auth_hash');
      await removeItem('auth_token');
      await removeItem('refresh_token');
      await removeItem('return_url');
      await removeItem('login_data');
      await removeItem('abroadOTP');
      await removeItem('isOrgEmployeeLogin');
      await removeCookieItem('HttpModuleLoginCookie', '/', Config.environmentCookieDomain);
      await removeCookieItem('ASP.NET_SessionId', '/', Config.environmentCookieDomain);
      await removeCookieItem('cellcom_cookie', '/', Config.environmentCookieDomain);
    } catch (err) {
      console.error(err);
    }
  },

  getUserDetails: async (token, isRedirect = true, isFull = true) => {
    const requestConfig = {
      method: 'post',
      baseURL: Config.loginApiUrl,
      url: '/api/getTokenDetails',
      data: {},
      headers: {
        Authorization: `Bearer ${token || getItem('auth_token')}`,
        'Content-Type': 'application/json',
      },
    };

    try {
      const response = await axios(requestConfig);
      const userDetails =
        response.data?.Body?.PRIVATE_IDF != null
          ? response.data?.Body?.PRIVATE_IDF
          : response.data?.Body?.PRIVATE_WEBSITE != null
          ? response.data?.Body?.PRIVATE_WEBSITE
          : response.data?.Body?.ONBEHALF;
      const customerData = await ProviderManager.getProviderData('customerInit', []);
      setOrganizationDataNewSelfCare(customerData);

      if (isFull) {
        try {
          //-------------- organizationId --------------
          setOrganizationDataOldWelcomeBlock(customerData);
          //-------------- trackingId --------------
          const trackingId = customerData?.Body?.trackingId;
          if (trackingId && trackingId != '') {
            let item = getItemWithExpiry('trackingId');
            setItemWithExpiry('trackingId', trackingId, Config.customerTrackingExpiryTimeInDays);
            if (item == undefined) {
              // new login detected
              reportTracking();
            }
          }
          //-------------- trackingId --------------
        } catch (err) {
          console.error(err);
        }
      }
      try {
        /* removing unneeded fields in auth */
        if (userDetails) {
          delete userDetails.LoginData.PaymentNumber;
          userDetails.LoginData.loginSubType =
            response.data?.Body?.PRIVATE_IDF != null
              ? loginSubTypes.PRIVATE_IDF
              : response.data?.Body?.PRIVATE_WEBSITE != null
              ? loginSubTypes.PRIVATE_WEBSITE
              : loginSubTypes.ONBEHALF;

          //--------onBoarding--------
          const isIDF = response.data?.Body?.PRIVATE_IDF != null;
          const isIDFExistingCustomer = isIDF && response.data?.Body?.PRIVATE_IDF?.RoleList?.includes('IDFOTP_CUSTOMEREXIST');
          if (!isIDF || isIDFExistingCustomer) {
            const store = await EpiContext.getStore();
            store.dispatch(Onboarding());
          }
        }
        /* end of removing */
      } catch (err) {
        console.error(err);
      }

      return userDetails;
    } catch (err) {
      if (isRedirect) window.location.href = Config.staticWebSiteUrl;
      throw err;
    }
  },

  getTokenDetails: async (token) => {
    const requestConfig = {
      method: 'post',
      baseURL: Config.loginApiUrl,
      url: '/api/getTokenDetails',
      data: {},
      headers: {
        Authorization: `Bearer ${token || getItem('auth_token')}`,
        'Content-Type': 'application/json',
      },
    };
    try {
      const response = await axios(requestConfig);
      return response.data?.Body?.PRIVATE_WEBSITE;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  isPravteUser: (role) => {
    return (role & 1 || role & 2) > 0;
  },

  isBusinessUser: (role) => {
    return (role & 4 || role & 8 || role & 16) > 0;
  },

  isPrivateOrBusinessPage: (url) => {
    return url.toLowerCase().includes(Config.businessLobbyUrl.toLowerCase()) || url.toLowerCase().includes(Config.lobbyUrl.toLowerCase());
  },

  getLoginUrl: (returnUrl, cancelUrl, template) => {
    let hash = getItem('auth_hash');
    if (hash === undefined) {
      hash = uuid();
      setItem('auth_hash', hash);
    }

    const sessionId = getSessionId();

    const loginUrl = replacer(Config.loginUrlTemplate, {
      client_id: Config.client_id,
      siteScope: Config.siteScope,
      loginType: 'NEWCREDENTIALS',
      template: template ? template : Config.defaultLoginTemplate,
      returnUrl: returnUrl,
      cancelUrl: cancelUrl,
      sid: sessionId,
      hash: hash,
    });

    return loginUrl;
  },
  getIdfLoginUrl: (returnUrl, cancelUrl, template) => {
    let hash = getItem('auth_hash');
    if (hash === undefined) {
      hash = uuid();
      setItem('auth_hash', hash);
    }

    const sessionId = getSessionId();

    const loginUrl = replacer(Config.idfLoginUrlTemplate, {
      loginType: 'IDFOTP',
      siteScope: 'PRIVATE_IDF',
      template: template ? template : Config.defaultLoginTemplate,
      returnUrl: returnUrl,
      cancelUrl: cancelUrl,
      sid: sessionId,
      hash: hash,
    });

    return loginUrl;
  },
};

Object.freeze(AuthenticationProvider);
export default AuthenticationProvider;
